import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { SOFTLINE_API_BONUSABFRAGE_UMSATZ } from '../bonusabfrage.api';
import { Revenue } from '../types/revenue';
import { BonusabfrageQuery } from '../types/bonusabfrage-query';

@Injectable()
export class RevenueRepository extends ReadonlyHttpApiListRepository<
  Result<Revenue[]>,
  BonusabfrageQuery | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_BONUSABFRAGE_UMSATZ);
  }

  override getLoadQueryParams(params: BonusabfrageQuery): Dictionary<unknown> {
    return {
      bonusPeriod: params.bonusPeriod,
      billingDate: params.billingDate,
    };
  }
}
